// Pricing source of truth for ResyNote.
// Prices are shown in INR (primary), USD, and EUR.
// If you change pricing, update Terms.jsx and RefundPolicy.jsx copy too.

export const CURRENCIES = [
  { code: "INR", symbol: "₹", label: "INR" },
  { code: "USD", symbol: "$", label: "USD" },
  { code: "EUR", symbol: "€", label: "EUR" },
];

export const PLANS = [
  {
    id: "trial",
    tier: "Free trial",
    prices: { INR: "0", USD: "0", EUR: "0" },
    note: "15 days · all features",
    cta: "Start free",
  },
  {
    id: "monthly",
    tier: "Monthly",
    prices: { INR: "199", USD: "2.49", EUR: "2.29" },
    suffix: "/mo",
    note: "per month · cancel anytime",
    cta: "Go monthly",
    featured: true,
  },
  {
    id: "annual",
    tier: "Annual",
    prices: { INR: "1,999", USD: "23.99", EUR: "21.99" },
    suffix: "/yr",
    note: "save ~16% vs monthly",
    cta: "Save with annual",
  },
];

export function formatPrice(plan, currencyCode) {
  const c = CURRENCIES.find((x) => x.code === currencyCode) || CURRENCIES[0];
  const amount = plan.prices[c.code];
  return `${c.symbol}${amount}`;
}
